<template lang="pug">
  .vendor-upload-spotplan(v-loading="loading")
    template(v-if="result.state != null")
      title-bar {{ $t('市场部审核Spotplan') }}
      procurement-audit-view(
        :status="result.status"
        :time="result.date"
        :remark="result.comment"
      )
    title-bar Spotplan
    spotplan(
      v-if="data"
      @upload="upload"
      :data="data"
    )
    el-row(v-if="!isView")
      el-col(
        :span="20"
        :offset="4"
      )
        footer-button(
          :confirmButton="$t('提交')"
          @confirm="submit"
          @cancel="cancel"
        )
</template>
<script>
import TitleBar from '@/components/TitleBar'
import Spotplan from './Spotplan'
import ProcurementAuditView from '@/components/ProcurementAuditView'
import axios from 'axios'
import FooterButton from '@/components/FooterButton'
import SendEmailDialog from '@/components/SendEmailDialog'

export default {
  components: {
    TitleBar,
    Spotplan,
    ProcurementAuditView,
    FooterButton,
    SendEmailDialog
  },
  data () {
    return {
      data: null,
      file: null,
      result: {},
      email: '',
      cc: '',
      loading: false
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    }
  },
  mounted () {
    this.fetchData()
    this.fetchResult()
  },
  methods: {
    fetchData () {
      axios
        .get('/management/subfinal/getCompletedProgress', {
          params: {
            sub_final_scope_id: this.$store.state.campaign.subFinalScopeId
          }
        })
        .then((res) => {
          this.data = res
        })
    },
    fetchResult () {
      axios
        .get('/management/subfinal/getApproveResult', {
          params: {
            id: this.$store.state.campaign.subFinalScopeVendorId,
            business_type: this.$store.state.campaign.businessType,
            audit_type: 6
          }
        })
        .then((res) => {
          this.result = res
        })
    },
    upload (file) {
      this.file = file
    },
    submit () {
      this.loading = true
      const formData = new window.FormData()
      formData.append('file', this.file)
      formData.append('sub_final_scope_vendor_id', this.$store.state.campaign.subFinalScopeVendorId)
      formData.append('servlet_path', this.$route.path)
      formData.append('task_name', this.$store.state.campaign.taskName)
      // formData.append('email', this.email)
      axios
        .post('/management/subfinal/uploadSpotPlan', formData)
        .then(() => {
          this.loading = false
          this.$router.push('/vendor-campaign/process')
        })
    },
    cancel () {
      this.$router.push('/vendor-campaign/process')
    }
  }
}
</script>
